import { render, staticRenderFns } from "./MenuContract.vue?vue&type=template&id=50a679ae&scoped=true&"
import script from "./MenuContract.vue?vue&type=script&lang=js&"
export * from "./MenuContract.vue?vue&type=script&lang=js&"
import style0 from "./MenuContract.vue?vue&type=style&index=0&id=50a679ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a679ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VTooltip})
